<!--
 * @Author: zhonghao
 * @Date: 2023-09-07 13:55:56
-->
<template>
  <div class="day-answer" v-track="{functionName: '训练营'}" @click="handleClick">
    <img src="@/assets/images/training/img(45).png" class="img-bg" alt="">
    <!-- <img src="@/assets/images/home/bottom_icon_topic@2x.png" class="day-img" alt="">
    <div class="txt-block">
      <div class="label-btn">题目描述</div>
      <div class="vals" v-if="dayDetails.questionTitle">{{ dayDetails && dayDetails.questionTitle }}</div>
      <img v-else :src="questionImage && questionImage.url" class="day-img2" alt="">
    </div> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      dayDetails: {
        questionTitle: ''
      },
      questionImage: {
      }
    }
  },
  mounted () {
  },
  methods: {
    handleClick () {
      localStorage.setItem('functionUrl', `${process.env.baseURL}${process.env.BASE_URL}/trainingList`)
      this.$router.push({
        path: '/trainingList'
      })
    }
  }
}
</script>
<style lang="less" scoped>
.day-answer {
  .img-bg {
    width: 100%;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/Training.vue